// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__dMtg1","loader":"MediumLoader_loader__xT4x+","spinner-c7wet2":"MediumLoader_spinner-c7wet2__EkkrU"};